<div class="w-full h-screen bg-black flex justify-center items-center flex-col">
  <img src="/assets/images/sidebar-logo.svg" class="size-28" alt="Logo"/>
  <h1 class="text-[#D54144] text-xl lg:text-3xl font-bold mt-5">ONLY USED TESLA</h1>
</div>
